import { FieldValues, useForm, UseFormReturn } from 'react-hook-form';
import { ReactNode } from 'react';

export enum OhsFormLayoutType {
  AngularPageForm,
  AngularModalForm,
  AngularModalUnderlinedForm,
}

export class OhsFormSettings<TFieldValues extends FieldValues = FieldValues> {
  useFormMethods: UseFormReturn<TFieldValues>;
  layout: OhsFormLayoutType;
  constructor(defaultValues: any, layout: OhsFormLayoutType) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    this.useFormMethods = useForm<TFieldValues>({
      defaultValues: defaultValues,
    });
    this.layout = layout;
  }
}
export interface OhsFormFieldBaseProps {
  title?: string;
  description?: string;
  labelEle?: ReactNode;
  noLabel?: boolean;
  required: boolean;
  id: string;
  ohsFormSettings: OhsFormSettings;
  hide?: boolean;
  disabled?: boolean;
  defaultValue?: any;
  resetOnHide?: boolean;
  renderAction?: ReactNode;
}
